/**
 * Service for handling timezone calculations and reset timers
 */
export class TimezoneService {
  /**
   * Calculate time until KST midnight (Korean Standard Time reset)
   * @returns Object with hours and minutes until reset
   */
  static getTimeUntilKSTReset(): { hours: number; minutes: number } {
    const now = new Date();
    // 한국 시간(KST) 기준 자정 계산
    const kstOffset = 9 * 60; // KST는 UTC+9
    const localOffset = now.getTimezoneOffset(); // 로컬 시간대의 UTC 오프셋 (분 단위)
    const offsetDiff = kstOffset + localOffset; // KST와 로컬 시간의 차이
    
    // 한국 시간 기준 다음 자정 계산
    const kstNow = new Date(now.getTime() + offsetDiff * 60 * 1000);
    const kstMidnight = new Date(kstNow);
    kstMidnight.setHours(24, 0, 0, 0);
    
    // 로컬 시간으로 변환
    const localMidnight = new Date(kstMidnight.getTime() - offsetDiff * 60 * 1000);
    
    const diff = localMidnight.getTime() - now.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    return { hours, minutes };
  }

  /**
   * Format time until reset as string
   * @param hours - Hours until reset
   * @param minutes - Minutes until reset
   * @returns Formatted string
   */
  static formatResetTime(hours: number, minutes: number): string {
    if (hours > 0) {
      return `${hours}시간 ${minutes}분 후 초기화`;
    }
    return `${minutes}분 후 초기화`;
  }

  /**
   * Check if it's near midnight (within 1 hour)
   * @returns True if close to reset time
   */
  static isNearReset(): boolean {
    const { hours } = this.getTimeUntilKSTReset();
    return hours === 0;
  }
}